import { SimpleSpeakerAvatar } from "@/components/SpeakerAvatar/SpeakerAvatar";

type VirtualAgentProps = {
  name: string;
  bold?: boolean;
};

export function VirtualAgent({ name, bold = false }: VirtualAgentProps) {
  return (
    // gap-2 matches the avatar-to-text spacing of the `UserName` block, which
    // renders the other rows of the same participants list.
    <div className="flex items-center gap-2">
      <SimpleSpeakerAvatar isVirtualAgent variant="green" />
      <span
        className={
          bold ? "text-xs font-bold text-primary" : "text-xs font-medium"
        }
      >
        {name}
      </span>
    </div>
  );
}
